require('../css/index.css');

import React from 'react';
import { render } from 'react-dom';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';

// import routes from './constants/routes';

import App from './containers/App';
import Home from './components/home/Home';

// eslint-disable-next-line
render(
  <Router history={browserHistory}>
    <Route path="/" component={App}>

      <IndexRoute component={Home} />
    </Route>
  </Router>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./client/js/index.js